import { Bloom as BloomPass } from '@react-three/postprocessing';
import { KERNEL_SIZE } from '@artica/constants';
import { KernelSize } from 'postprocessing';

export default function Bloom() {
  return (
    <BloomPass
      mipmapBlur={ true }
      kernelSize={ KernelSize[KERNEL_SIZE] }
      radius={ 0.8 }
      intensity={ 5.30 }
      luminanceThreshold={ 0.80 }
      luminanceSmoothing={ 0.1 }
    />
  );
};